import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { PrismIllustration } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import GeneralButtonsChoiceSegmentButton from 'lumen/components/general/buttons/choice-segment-button';
import type { Method } from 'lumen/components/settings/budget-forecast/upload-download-modal';

interface SettingsBudgetForecastUploadDownloadModalMethodSectionSignature {
  Args: {
    method: Method;
    setMethod: (method: Method) => void;
    view: 'budget' | 'forecast';
  };
}

const SettingsBudgetForecastUploadDownloadModalMethodSection = <template>
  <p class="text-300--regular">
    {{if
      (eq @view "budget")
      (t "budget_forecast.upload_budget.description")
      (t "budget_forecast.upload_forecast.description")
    }}
  </p>

  <div class="grid grid-cols-2 gap-500">
    <GeneralButtonsChoiceSegmentButton
      @isChecked={{eq @method "download"}}
      @label={{t "budget_forecast.download_template"}}
      @onClick={{fn @setMethod "download"}}
      @type="radio"
    >
      <div class="flex justify-center">
        <PrismIllustration @name="100x100_list" @size="medium" />
      </div>
    </GeneralButtonsChoiceSegmentButton>

    <GeneralButtonsChoiceSegmentButton
      @isChecked={{eq @method "upload"}}
      @label={{if
        (eq @view "budget")
        (t "budget_forecast.upload_budget.title")
        (t "budget_forecast.upload_forecast.title")
      }}
      @onClick={{fn @setMethod "upload"}}
      @type="radio"
    >
      <div class="flex justify-center">
        <PrismIllustration @name="100x100_upload" @size="medium" />
      </div>
    </GeneralButtonsChoiceSegmentButton>
  </div>
</template> satisfies TOC<SettingsBudgetForecastUploadDownloadModalMethodSectionSignature>;

export default SettingsBudgetForecastUploadDownloadModalMethodSection;
